module.exports = __webpack_public_path__ + "img/skridsko_snois.7bb7779b.jpg";